module.exports = __webpack_public_path__ + "static/media/heart-head-handshake.8c6f62c7.jpg";